// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";

var initialState_posts = [];

var initialState_unsorted_posts = [];

var initialState = {
  posts: initialState_posts,
  unsorted_posts: initialState_unsorted_posts,
  loading: false,
  sort: /* NoSort */0
};

function compareStrings(string_a, string_b) {
  return string_b.localeCompare(string_a) | 0;
}

function reducer(appState, appAction) {
  if (typeof appAction === "number") {
    if (appAction === /* StartFetch */0) {
      return {
              posts: initialState_posts,
              unsorted_posts: initialState_unsorted_posts,
              loading: true,
              sort: /* NoSort */0
            };
    } else {
      return initialState;
    }
  }
  if (appAction.TAG === /* FetchSuccess */0) {
    var posts = appAction._0;
    return {
            posts: posts,
            unsorted_posts: posts,
            loading: false,
            sort: /* NoSort */0
          };
  }
  var sort = appAction._0;
  switch (sort) {
    case /* NoSort */0 :
        return {
                posts: appState.unsorted_posts,
                unsorted_posts: appState.unsorted_posts,
                loading: appState.loading,
                sort: /* NoSort */0
              };
    case /* SortByTitle */1 :
        return {
                posts: Belt_SortArray.stableSortBy(appState.unsorted_posts, (function (post_a, post_b) {
                        return post_a.title.localeCompare(post_b.title) | 0;
                      })),
                unsorted_posts: appState.unsorted_posts,
                loading: appState.loading,
                sort: sort
              };
    case /* SortByTitleDesc */2 :
        return {
                posts: Belt_SortArray.stableSortBy(appState.unsorted_posts, (function (post_a, post_b) {
                        return post_b.title.localeCompare(post_a.title) | 0;
                      })),
                unsorted_posts: appState.unsorted_posts,
                loading: appState.loading,
                sort: sort
              };
    case /* SortByScore */3 :
        return {
                posts: Belt_SortArray.stableSortBy(appState.unsorted_posts, (function (post_a, post_b) {
                        return post_a.score - post_b.score | 0;
                      })),
                unsorted_posts: appState.unsorted_posts,
                loading: appState.loading,
                sort: sort
              };
    case /* SortByScoreDesc */4 :
        return {
                posts: Belt_SortArray.stableSortBy(appState.unsorted_posts, (function (post_a, post_b) {
                        return post_b.score - post_a.score | 0;
                      })),
                unsorted_posts: appState.unsorted_posts,
                loading: appState.loading,
                sort: sort
              };
    case /* SortByDate */5 :
        return {
                posts: Belt_SortArray.stableSortBy(appState.unsorted_posts, (function (post_a, post_b) {
                        return (post_b.time | 0) - (post_a.time | 0) | 0;
                      })),
                unsorted_posts: appState.unsorted_posts,
                loading: appState.loading,
                sort: sort
              };
    case /* SortByDateDesc */6 :
        return {
                posts: Belt_SortArray.stableSortBy(appState.unsorted_posts, (function (post_a, post_b) {
                        return (post_a.time | 0) - (post_b.time | 0) | 0;
                      })),
                unsorted_posts: appState.unsorted_posts,
                loading: appState.loading,
                sort: sort
              };
    
  }
}

var sortBy = Belt_SortArray.stableSortBy;

export {
  initialState ,
  sortBy ,
  compareStrings ,
  reducer ,
  
}
/* No side effect */
